import i18n from 'utils/i18n'
import type { AdminELabelsFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  SEARCH_USERS,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationElabelsFilterCollection = () => [
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.userFilter),
    filterName:
      ADMIN_FILTERS_NAME.updateUserUsernameFilter satisfies AdminELabelsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.updateUserUsernameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.producerFilter),
    filterName:
      ADMIN_FILTERS_NAME.producerFilter satisfies AdminELabelsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.producerFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.countryFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineCountryFilter satisfies AdminELabelsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.statusFilter),
    filterName:
      ADMIN_FILTERS_NAME.statusFilter satisfies AdminELabelsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.statusFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.createdAtFilter satisfies AdminELabelsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.lastUpdateFilter),
    filterName:
      ADMIN_FILTERS_NAME.updatedAtFilter satisfies AdminELabelsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.updatedAtFilter,
  },
]

export const adminElabelsFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationElabelsFilterCollection,
  pathToStore: ['offers'],
  filtersDataPath: ['admin', 'productELabels', 'productELabelsFilters'],
  showResultsTextKey: 'filters.button.apply',
}
